<template>
  <div>
    <FinanceSalarySliceShowTable
      :employee="employeeLabel"
      :period="period"
      :show-project-id="showProjectId"
    >
      <FinanceSalarySliceShowTableHeader :show-project-id="showProjectId" />
      <FinanceSalarySliceShowTableTotal
        v-for="(project, p) in employee.projects"
        :key="'total_employee_project_' + p"
        :works="Object.values(project.work_types)"
        :extras="Object.values(project.extras)"
        :project-id="project.internal_project_id"
        :project-name="project.name"
        :position-plus="project.positionPlus"
        :responsible-total-show="false"
        :show-project-id="showProjectId"
      />
    </FinanceSalarySliceShowTable>
    <template v-if="employee.previous || employee.current">
      <div v-for="type in ['previous', 'current']" :key="type">
        <FinanceSalarySliceShowTable
          v-if="employee[type]"
          :show-project-id="showProjectIdByType(type)"
          :show-timestamp="showTimestampByType(type)"
        >
          <div
            slot="title"
            :class="type === 'current'
              ? 'pb-5 subtitle d-flex align-center justify-space-between flex-wrap'
              : 'pb-5 subtitle'"
          >
            <span>
              {{
                localStorage.translations.pages.finance['salary-table'][
                  type === 'previous' ? 'balance' : 'current'
                ]
              }}
            </span>
            <BaseButton
              v-if="type === 'current'"
              :text="foremanVisible
                ? localStorage.translations.pages.finance['salary-table']['hide_foreman_column']
                : localStorage.translations.pages.finance['salary-table']['show_foreman_column']"
              height="30"
              @click="toggleForemanColumn"
            />
          </div>
          <FinanceSalarySliceShowTableHeader
            :responsible-total-show="isResponsibleVisible(type)"
            :show-project-id="showProjectIdByType(type)"
            :show-timestamp="showTimestampByType(type)"
            :use-foreman-approved-title="type === 'current'"
            by-days
          >
            <div slot="first">
              <BaseCheckbox
                v-if="changedData[type]"
                v-model="changedData[type].checkboxData"
                class="mr-2"
                @input="changeCheckboxData(type)"
                :disabled="!checkEditAccess || changedData[type].checkboxDisabled"
                :key="Number(changedData[type].checkboxData)"
              />
            </div>
            <div slot="second">
              <BaseCheckbox
                v-if="changedDataResponsible[type] && (!checkEditAccess || changedData[type] && changedData[type].checkboxDisabled || counter > 0 || fillCheck)"
                v-model="changedDataResponsible[type].checkboxData"
                class="mr-2"
                @input="changeCheckboxResponsibleData(type)"
                :disabled="!checkEditAccess || changedDataResponsible[type].checkboxDisabled"
                :key="Number(changedDataResponsible[type].checkboxData)"
              />
            </div>
          </FinanceSalarySliceShowTableHeader>
          <FinanceSalarySliceShowTableByDays
            :data="employee[type]"
            :on-update="onUpdate"
            :start="period.start"
            :end="period.end"
            :ref="type"
            :responsible-show="isResponsibleVisible(type)"
            :force-responsible="type === 'current' && foremanVisible"
            :show-project-id="showProjectIdByType(type)"
            :show-timestamp="showTimestampByType(type)"
          />
          <template slot="button" v-if="changedData[type]">
            <BaseCheckbox
              v-if="!!changedData[type].changedData"
              :value="true"
              :disabled="!changedData[type].changedData"
              size="32"
              :key="
                Number(changedData[type].changedData) + '_' + Number(changedData[type].checkboxData)
              "
              class="ml-2"
              @input="saveChanges(type) "
            />
            <img
              v-if="changedData[type].checkboxDisabled && !changedData[type].changedData"
              src="../../../assets/img/approved.jpg"
              style="width: 100%"
            />
          </template>
          <template slot="button_responsible" v-if="changedDataResponsible[type] && isResponsibleVisible(type)">
            <BaseCheckbox
              v-if="!!changedDataResponsible[type].changedData"
              :value="true"
              :disabled="!changedDataResponsible[type].changedData"
              size="32"
              :key="
                Number(changedDataResponsible[type].changedData) + '_' + Number(changedDataResponsible[type].checkboxData)
              "
              class="ml-2"
              @input="saveChangesResponsible(type)"
            />
            <img
              v-if="changedDataResponsible[type].checkboxDisabled && !changedDataResponsible[type].changedData"
              src="../../../assets/img/approved.jpg"
              style="width: 100%"
            />
          </template>
        </FinanceSalarySliceShowTable>
      </div>
    </template>
  </div>
</template>

<script>
import FinanceSalarySliceShowTable from 'components/finance/salary/show/FinanceSalarySliceShowTable'
import FinanceSalarySliceShowTableHeader from 'components/finance/salary/show/FinanceSalarySliceShowTableHeader'
import FinanceSalarySliceShowTableTotal from 'components/finance/salary/show/FinanceSalarySliceShowTableTotal'
import FinanceSalarySliceShowTableByDays from 'components/finance/salary/show/FinanceSalarySliceShowTableByDays'
import { mapGetters } from 'vuex'
import BaseCheckbox from 'components/base/BaseCheckbox'
import BaseButton from 'components/base/BaseButton'

export default {
  name: 'FinanceSalarySliceShowEmployee',
  components: {
    BaseButton,
    BaseCheckbox,
    FinanceSalarySliceShowTableByDays,
    FinanceSalarySliceShowTableTotal,
    FinanceSalarySliceShowTableHeader,
    FinanceSalarySliceShowTable,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    period: {
      type: Object,
      default: () => {
        return {}
      },
    },
    checkEditAccess: Boolean,
    onUpdate: {},
    collection: {
      type: Object,
      default: () => {
        return {
          current: { employees: {} },
          previous: { employees: {} },
        }
      },
    },
    responsibleShow: Boolean,
    foremanVisible: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    counter: 0,
  }),
  computed: {
    employee() {
      let result = this.data
      let positionPlus = 0
      for (let p in result.projects) {
        result.projects[p].id = p
        result.projects[p].positionPlus = positionPlus
        positionPlus +=
          Object.keys(result.projects[p]['work_types']).length +
          (Object.keys(result.projects[p]['extras']).length ? 1 : 0)
      }
      let arr = ['current', 'previous']
      for (let a in arr) {
        let type = arr[a]
        if (this.collection[type].employees[this.id]) {
          result[type] = this.collection[type].employees[this.id].projects
          if (result[type] && result.projects) {
            Object.keys(result[type]).forEach((projectKey) => {
              if (
                result[type][projectKey] &&
                (result[type][projectKey].internal_project_id === null ||
                  result[type][projectKey].internal_project_id === '' ||
                  typeof result[type][projectKey].internal_project_id === 'undefined') &&
                result.projects[projectKey] &&
                (result.projects[projectKey].internal_project_id === 0 || result.projects[projectKey].internal_project_id)
              ) {
                result[type][projectKey].internal_project_id = result.projects[projectKey].internal_project_id
              }
            })
          }
        }
      }
      return result
    },
    checkResponsibleShow() {
      let result = false
      let days = []
      let arr = ['current', 'previous']
      for (let a in arr) {
        let type = arr[a]
        days = this.$GetDaysByProjectsFinanceSalary(this.employee[type], true)
        for (let d in days) {
          for (let p in days[d].projects) {
            let arr = ['extras', 'work_types']
            for (let a in arr) {
              if (days[d].projects[p][arr[a]]) {
                for (let w in days[d].projects[p][arr[a]]) {
                  for (let r in days[d].projects[p][arr[a]][w].reports) {
                    if (days[d].projects[p][arr[a]][w].reports[r] && days[d].projects[p][arr[a]][w].reports[r].responsible_user_id !== null)
                      result = true
                  }
                }
              }
            }
          }
        }
      }
      return result
    },
    changedData() {
      let result = {}
      let arr = ['previous', 'current']
      for (let a in arr)
        if (this.$refs[arr[a]] && this.$refs[arr[a]][0]) {
          let list = Object.values(this.$refs[arr[a]][0].checkboxData)
          result[arr[a]] = {
            changedData:
              this.$refs[arr[a]] && this.$refs[arr[a]][0]
                ? this.$refs[arr[a]][0].changedData
                : false,
            checkboxData: list.every((e) => {
              return e.value
            })
              ? true
              : list.every((e) => {
                return e.value === false
              })
                ? false
                : null,
            checkboxDisabled: list.every((e) => {
              return e.disabled
            }),
          }
        }
      return result
    },
    changedDataResponsible() {
      let result = {}
      let arr = ['previous', 'current']
      for (let a in arr)
        if (this.$refs[arr[a]] && this.$refs[arr[a]][0]) {
          let list = Object.values(this.$refs[arr[a]][0].checkboxDataResponsible)
          result[arr[a]] = {
            changedData:
              this.$refs[arr[a]] && this.$refs[arr[a]][0]
                ? this.$refs[arr[a]][0].changedDataResponsible
                : false,
            checkboxData: list.every((e) => {
              return e.value
            })
              ? true
              : list.every((e) => {
                return e.value === false
              })
                ? false
                : null,
            checkboxDisabled: list.every((e) => {
              return e.disabled_responsible
            }),
          }
        }
      return result
    },
    fillCheck() {
      let result = 0
      let type = this.changedDataResponsible ? Object.keys(this.changedDataResponsible)[0] : null
      let temp = this.$refs[type] && this.$refs[type][0] ? this.$refs[type][0]['daysData'] : {}
      for (let i in temp) {
        if (temp[i].work.project_responsible_salary_sum > 0) result = result + 1
      }
      return result
    },
    showProjectId() {
      return this.hasProjectId(this.employee.projects) ||
        this.hasProjectId(this.employee.current) ||
        this.hasProjectId(this.employee.previous)
    },
    employeeLabel() {
      const name = [this.employee.first_name, this.employee.last_name]
        .filter(Boolean)
        .join(' ')
        .trim()
      const externalId = this.employee.external_id
      if (externalId) {
        return name
          ? `${name}, ${
            this.localStorage.translations.pages.common.text['worker_id'] || 'Worker ID'
          }: ${externalId}`
          : `${
            this.localStorage.translations.pages.common.text['worker_id'] || 'Worker ID'
          }: ${externalId}`
      }
      return name
    },
  },
  methods: {
    hasProjectId(data) {
      if (!data) return false
      return Object.values(data).some((project) => {
        return project &&
          project.internal_project_id !== null &&
          project.internal_project_id !== '' &&
          typeof project.internal_project_id !== 'undefined'
      })
    },
    showProjectIdByType(type) {
      return type === 'current' && this.showProjectId
    },
    showTimestampByType(type) {
      return type === 'current'
    },
    isResponsibleVisible(type) {
      if (type === 'current') return this.foremanVisible
      return this.responsibleShow && this.checkResponsibleShow
    },
    toggleForemanColumn() {
      this.$emit('toggle-foreman')
    },
    firstChange(change) {
      if (change) this.counter = this.counter + 1
      
      let type = this.changedDataResponsible ? Object.keys(this.changedDataResponsible)[0] : null
      if (this.changedDataResponsible[type] && this.changedDataResponsible[type].checkboxData !== false ||
        this.changedData[type] && this.changedData[type].checkboxData !== false && this.changedData[type].changedData !== true)
        this.counter = this.counter + 1
    },
    changeCheckboxData(type) {
      let value = this.changedData[type] ? this.changedData[type].checkboxData : null
      if (this.$refs[type])
        for (let i in this.$refs[type][0].$refs)
          if (!this.$refs[type][0].$refs[i][0].report['paid_report'])
            this.$refs[type][0].$refs[i][0].setPaidChanges(!value)
    },
    changeCheckboxResponsibleData(type) {
      let value = this.changedDataResponsible[type] ? this.changedDataResponsible[type].checkboxData : null
      if (this.$refs[type])
        for (let i in this.$refs[type][0].$refs) {
          if (!this.$refs[type][0].$refs[i][0].report['project_responsible_approved'] && this.$refs[type][0].$refs[i][0].report['project_responsible_salary_sum'] > 0)
            this.$refs[type][0].$refs[i][0].setPaidResponsibleChanges(!value)
        }
    },
    saveChanges(type) {
      let temp = this.$refs[type] && this.$refs[type][0] ? this.$refs[type][0]['daysData'] : {}
      let extras = []
      let works = []
      for (let i in temp) {
        if (temp[i].changedData) {
          let tmp = {}
          temp[i].work.is_hourly === 1 || temp[i].isExtra
            ? (tmp['paid_hours'] = temp[i].paid_report)
            : (tmp['paid_size'] = temp[i].paid_report)
          tmp['paid_notes'] = temp[i].paid_notes || ''
          tmp.id = temp[i].id
          temp[i].isExtra ? extras.push(tmp) : works.push(tmp)
        }
      }
     this.firstChange(true)
      if (this.onUpdate) {
        this.onUpdate(extras, true, true, false)
        this.onUpdate(works, true, false, false)
      }
    },
    saveChangesResponsible(type) {
      let temp = this.$refs[type] && this.$refs[type][0] ? this.$refs[type][0]['daysData'] : {}
      let extras = []
      let works = []
      for (let i in temp) {
        if (temp[i].changedDataResponsible) {
          let tmp = {
            project_responsible_approved: temp[i].work.project_responsible_salary_sum,
            id: temp[i].id
          }
          temp[i].isExtra ? extras.push(tmp) : works.push(tmp)
        }
      }
      if (this.onUpdate) {
        this.onUpdate(extras, true, true, true)
        this.onUpdate(works, true, false, true)
      }
    }
  },
}
</script>
